import React from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../shared/helpers/i18n';
import { selectSortedWaitingRoomPeers, selectWaitingRoomIsEmpty } from '../../selectors';
import { ConferenceLimitWarning } from '../conference-limit-warning';
import { EmptyStub } from '../empty-stub';
import { WaitingRoomPeer } from './waiting-room-peer';

export const WaitingRoomPeersList = () => {
    const waitingRoomPeers = useSelector(selectSortedWaitingRoomPeers);
    const waitingRoomIsEmpty = useSelector(selectWaitingRoomIsEmpty);

    if (waitingRoomIsEmpty) {
        return (
            <EmptyStub
                imageName="waitingRoomStub"
                title={i18n('participants-sidebar', 'waiting-room-stub-title')}
                text={i18n('participants-sidebar', 'waiting-room-stub-text')}
            />
        );
    }

    return (
        <>
            <ConferenceLimitWarning />
            {waitingRoomPeers.map((peer) => (
                <WaitingRoomPeer key={peer.id} peer={peer} />
            ))}
        </>
    );
};
